import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import BrowserLogger from 'alife-logger';
import VConsole from 'vconsole';
import { version } from '../../package.json';
var VUE_APP_ENV = process.env.VUE_APP_ENV;
var ENVIRONMENT = {
  production: 'prod',
  development: 'local',
  test: 'daily',
  realpre: 'pre'
};
var testTargetUrl = /^test-h5.ubanquan.cn/.test(window.location.hostname);
var testTargetUrl2 = /^test2-h5.ubanquan.cn/.test(window.location.hostname);
var testTargetUrl3 = /^test-x.ubanquan.cn/.test(window.location.hostname); // 不是ip和localhost地址

var prodTargetUrl = !/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(location.hostname) && location.hostname !== 'localhost'; // 错误上报环境启用

var loggerConfigHandler = function loggerConfigHandler() {
  var bl = BrowserLogger.singleton({
    pid: 'b3efcz0rox@60568d2b557946c',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    environment: ENVIRONMENT[VUE_APP_ENV],
    release: version
  });
  bl.setConfig({
    ignore: {
      ignoreUrls: ['https://s9.cnzz.com/', 'https://obs.prod.ubanquan.cn'],
      ignoreApis: [/^umini.shujupie.com/, 'https://qiyukf.com/'],
      ignoreErrors: [],
      ignoreResErrors: []
    }
  });
};

var initReportHandler = function initReportHandler() {
  // 非生产环境启用
  if (testTargetUrl || testTargetUrl2 || testTargetUrl3) {
    new VConsole();
  } // 线上环境启用


  if (VUE_APP_ENV === 'production' && prodTargetUrl) {
    loggerConfigHandler();
  }
};

initReportHandler();